import { useActivityCurrentUserRole } from "PFApp/activities/hooks";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { TemplateKey } from "PFApp/constants/templates";
import { useTemplate } from "PFApp/hooks";
import { Tile } from "PFComponents/tile";

import { OwnerFlow } from "./owner_flow";
import { ReviewerFlow } from "./reviewer_flow";

export const ActivityReviewSection = () => {
  const activity = useCurrentActivity();
  const { isReviewer } = useActivityCurrentUserRole(activity);
  const activityType = useTemplate(activity?.template_id);
  const isAuditRole = activityType?.key === TemplateKey.AuditRole;

  if ((!isReviewer && !activity.coowned) || isAuditRole) {
    return null;
  }

  return (
    <Tile paddingVariant="lg" variant="light">
      <div>
        {isReviewer && <ReviewerFlow />}
        {!isReviewer && activity.coowned && <OwnerFlow />}
      </div>
    </Tile>
  );
};
